(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["r4-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('r4-carousel')) {
  customElements.define('r4-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-r4-slide]'));
      this.index = 0;
      this.paused = false;
      this.pauseButton = this.querySelector('[data-r4-pause]');
      this.querySelector('[data-r4-next]').addEventListener('click', () => this.show(this.index + 1));
      this.querySelector('[data-r4-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); });
      this.updatePause();
      this.timer = window.setInterval(() => {
        if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.show(this.index + 1);
      }, 6500);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.querySelector('[data-r4-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    updatePause() {
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? '배너 자동 전환 재생' : '배너 자동 전환 정지');
    }
    disconnectedCallback() { window.clearInterval(this.timer); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
